import { render, staticRenderFns } from "./VariantCard.vue?vue&type=template&id=76315178&scoped=true&"
import script from "./VariantCard.vue?vue&type=script&lang=ts&"
export * from "./VariantCard.vue?vue&type=script&lang=ts&"
import style0 from "./VariantCard.vue?vue&type=style&index=0&id=76315178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76315178",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,StoreCardLayout: require('/home/vsts/work/1/a/NuxtApp/components/store/card/Layout.vue').default})
